import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
const CollegeTour = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const courses = [
    {
      id: 'bpharma',
      title: 'B.Pharma',
      fullTitle: 'Bachelor of Pharmacy',
      duration: '4 Years (8 Semesters)',
      gradient: 'from-sky-600 to-red-600',
      lightGradient: 'from-sky-50 to-red-50',
      icon: (
        <svg className="w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 8H9L8 4z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 12v.01" />
        </svg>
      ),
      description: "The B.Pharm Course has been specially designed by Dr. APJAKTU for those who are eager to acquire professional skill in the field of pharmaceutical education. This definitely provides employment and business opportunities anywhere across the globe.",
      features: [
        "8 Semesters with Theory & Practicals",
        "Industrial Training & Project Work",
        "Global Career Opportunities",
        "Research Based Curriculum"
      ],
      eligibility: "10+2 with PCB/PCM (50% aggregate)",
      careers: ["Clinical Pharmacist", "Pharmaceutical Researcher", "Drug Inspector", "Pharmacy Business Owner"],
      highlights: ["Approved by PCI & AICTE", "100% Placement Assistance", "Industry Expert Lectures", "Modern Labs & Equipment"]
    },
    {
      id: 'dpharma',
      title: 'D.Pharma',
      fullTitle: 'Diploma in Pharmacy',
      duration: '2 Years Program',
      gradient: 'from-red-600 to-sky-600',
      lightGradient: 'from-red-50 to-sky-50',
      icon: (
        <svg className="w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      description: "A comprehensive diploma program designed to build strong foundations in pharmaceutical sciences with practical training and industry exposure. The course focuses on developing skilled pharmacy professionals ready for the industry.",
      features: [
        "Yearly Examination System",
        "Individual Training Program",
        "Practical Based Learning",
        "Industry Ready Curriculum"
      ],
      eligibility: "10+2 with 50% in PCB/PCM",
      careers: ["Career in Pharmacy", "Production & Manufacturing", "Research & Development", "Quality Control Analyst"],
      highlights: ["PCI Approved Course", "Hands-on Training", "Industry Partnerships", "Affordable Fees"]
    }
  ];

  const nextSlide = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setCurrentSlide((prev) => (prev + 1) % courses.length);
      setTimeout(() => setIsAnimating(false), 400);
    }
  };
  const prevSlide = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setCurrentSlide((prev) => (prev - 1 + courses.length) % courses.length);
      setTimeout(() => setIsAnimating(false), 400);
    }
  };
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide]);

  const currentCourse = courses[currentSlide];
  return (
    <section className="w-full bg-gradient-to-br from-gray-50 via-white to-gray-100 py-16 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-block mb-4">
              <span className="inline-flex items-center px-4 py-2 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold">
                <svg className="w-4 h-4 mr-2 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                Virtual Campus Experience
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Let's Have a
              <span className="bg-gradient-to-r from-sky-600 to-red-600 bg-clip-text text-transparent"> College Tour</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We provide always our best facilities for our students.
              <span className="block text-sky-600 font-semibold mt-1">Experience excellence in pharmaceutical education</span>
            </p>
          </div>
          <div className="relative">
            <div className={`transition-all duration-400 ${isAnimating ? 'opacity-0 transform scale-95' : 'opacity-100 transform scale-100'}`}>
              <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                <div className={`bg-gradient-to-r ${currentCourse.gradient} p-6 md:p-8 relative overflow-hidden`}>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-16 -mt-16"></div>
                  <div className="absolute bottom-0 left-0 w-32 h-32 bg-white opacity-10 rounded-full -ml-16 -mb-16"></div>
                  
                  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 relative z-10">
                    <div className="flex items-center gap-4">
                      <div className="text-white transform hover:scale-110 transition-transform duration-300">
                        {currentCourse.icon}
                      </div>
                      <div>
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-1">{currentCourse.title}</h3>
                        <p className="text-white text-opacity-90">{currentCourse.fullTitle}</p>
                      </div>
                    </div>
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-white bg-opacity-20 backdrop-blur-sm rounded-full text-white border border-white border-opacity-30">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span className="font-semibold text-sm">{currentCourse.duration}</span>
                    </div>
                  </div>
                </div>
                <div className="p-6 md:p-8">
                  <div className="grid lg:grid-cols-2 gap-8">
                    <div>
                      <div className="mb-6">
                        <h4 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                          <svg className="w-5 h-5 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                          </svg>
                          Program Overview
                        </h4>
                        <p className="text-gray-700 leading-relaxed">
                          {currentCourse.description}
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                          </svg>
                          Key Features
                        </h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          {currentCourse.features.map((feature, idx) => (
                            <div key={idx} className="flex items-center gap-2 text-gray-700 text-sm">
                              <svg className="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                              </svg>
                              {feature}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className={`bg-gradient-to-r ${currentCourse.lightGradient} rounded-xl p-4 mb-5 border-l-4 border-sky-500`}>
                        <div className="flex items-center gap-2 mb-2">
                          <svg className="w-5 h-5 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                          </svg>
                          <h4 className="font-bold text-gray-800">Eligibility Criteria</h4>
                        </div>
                        <p className="text-gray-700 text-sm">{currentCourse.eligibility}</p>
                      </div>

                      <div className={`bg-gradient-to-r ${currentCourse.lightGradient} rounded-xl p-4 mb-5 border-l-4 border-red-500`}>
                        <div className="flex items-center gap-2 mb-2">
                          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                          </svg>
                          <h4 className="font-bold text-gray-800">Career Opportunities</h4>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {currentCourse.careers.map((career, idx) => (
                            <span key={idx} className="px-2 py-1 bg-white text-gray-700 text-xs rounded-full shadow-sm border border-gray-200">
                              {career}
                            </span>
                          ))}
                        </div>
                      </div>
                      <div>
                        <h4 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                          <svg className="w-5 h-5 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
                          </svg>
                          Program Highlights
                        </h4>
                        <div className="grid grid-cols-2 gap-2">
                          {currentCourse.highlights.map((highlight, idx) => (
                            <div key={idx} className="flex items-center gap-2 text-gray-700 text-sm">
                              <svg className="w-3 h-3 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                              </svg>
                              {highlight}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3 mt-8 pt-6 border-t border-gray-200">
                    <Link
                      to={`/${currentCourse.id}`}
                      className={`flex-1 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-gradient-to-r ${currentCourse.gradient} text-white rounded-lg font-semibold text-sm hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300 group`}
                    >
                      <span>Read More About {currentCourse.title}</span>
                      <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                      </svg>
                    </Link>
                    <button className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-gradient-to-r from-sky-500 to-red-500 text-white rounded-lg font-semibold text-sm hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                      </svg>
                      Take Virtual Tour
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={prevSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 md:-ml-6 w-10 h-10 rounded-full bg-white shadow-lg text-sky-600 hover:bg-gradient-to-r hover:from-sky-600 hover:to-red-600 hover:text-white transition-all duration-300 flex items-center justify-center z-10 border border-gray-200"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>
            
            <button
              onClick={nextSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 md:-mr-6 w-10 h-10 rounded-full bg-white shadow-lg text-sky-600 hover:bg-gradient-to-r hover:from-sky-600 hover:to-red-600 hover:text-white transition-all duration-300 flex items-center justify-center z-10 border border-gray-200"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>
          <div className="flex justify-center gap-2 mt-8">
            {courses.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSlide(idx)}
                className={`transition-all duration-300 ${
                  currentSlide === idx
                    ? 'w-8 h-2 bg-gradient-to-r from-sky-600 to-red-600 rounded-full'
                    : 'w-2 h-2 bg-gray-300 rounded-full hover:bg-sky-400'
                }`}
              ></button>
            ))}
          </div>
          <div className="text-center mt-4">
            <p className="text-sm text-gray-500">
              <span className="text-sky-600 font-semibold">{currentSlide + 1}</span> / {courses.length}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollegeTour;